var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3346 9.00033C17.3346 13.6027 13.6037 17.3337 9.0013 17.3337C4.39893 17.3337 0.667969 13.6027 0.667969 9.00033C0.667969 4.39795 4.39893 0.666992 9.0013 0.666992C13.6037 0.666992 17.3346 4.39795 17.3346 9.00033ZM9.00132 5.87533C8.61706 5.87533 8.28005 6.08284 8.09837 6.39691C7.8103 6.8949 7.17309 7.06506 6.67511 6.777C6.17713 6.48893 6.00696 5.85172 6.29502 5.35374C6.83378 4.42239 7.84331 3.79199 9.00132 3.79199C10.7272 3.79199 12.1263 5.1911 12.1263 6.91699C12.1263 8.27764 11.2567 9.43518 10.043 9.86417V10.042C10.043 10.6173 9.57661 11.0837 9.00132 11.0837C8.42602 11.0837 7.95965 10.6173 7.95965 10.042V9.00033C7.95965 8.42503 8.42602 7.95866 9.00132 7.95866C9.57661 7.95866 10.043 7.49229 10.043 6.91699C10.043 6.3417 9.57661 5.87533 9.00132 5.87533ZM9.0013 14.2087C9.5766 14.2087 10.043 13.7423 10.043 13.167C10.043 12.5917 9.5766 12.1253 9.0013 12.1253C8.42601 12.1253 7.95964 12.5917 7.95964 13.167C7.95964 13.7423 8.42601 14.2087 9.0013 14.2087Z",
    fill: "#F08E0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.5056fa240c21230b89274b4370aed859.svg";
export { ForwardRef as ReactComponent };